/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserLoginDto } from '@api';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss'],
})
export class UserLoginComponent {
  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  /**
   * Form validation will start after the method is called, additionally an AuthRequest will be sent
   */
  loginUser() {
    if (this.loginForm.valid) {
      const authRequest: UserLoginDto = {
        username: this.loginForm.controls.username.value!,
        password: this.loginForm.controls.password.value!,
      };
      this.authenticateUser(authRequest);
    } else {
      console.log('Invalid input');
    }
  }

  /**
   * Send authentication data to the authService. If the authentication was successfully, the user will be forwarded to the tournaments page
   *
   * @param dto authentication data from the user login form
   */
  authenticateUser(dto: UserLoginDto) {
    console.log('Try to authenticate user: ' + dto.username);
    this.authService.loginUser(dto).subscribe({
      next: () => {
        console.log('Successfully logged in user: ' + dto.username);
        this.snackBar.open('Successfully logged in', 'Close', {
          duration: 3000,
        });
        this.router.navigate(['/admin/tournaments']);
      },
      error: error => {
        console.log('Could not log in due to:');
        console.log(error);
        let errorMessage = '';
        if (typeof error.error === 'object') {
          errorMessage = error.error.error;
        } else {
          errorMessage = error.error;
        }
        this.snackBar.open(errorMessage, 'Close', {});
      },
    });
  }
}
